import React from 'react';
import cx from 'classnames';
import Layout from '../common/Layout';
import Header from '../common/Header';
import GlobalSetting from '../GlobalSetting';

interface UserLayoutProps {
    className?: string;
    contentClassName?: string;
    [props: string]: any;
}

const UserLayout: React.FC<UserLayoutProps> = ({ children, contentClassName, ...props }) => {
    return (
        <Layout {...props}>
            <Header />
            <main className="flex w-full h-full">
                <div
                    className={cx(
                        'w-full mt-20 px-5 pb-5 overflow-x-hidden overflow-y-auto',
                        contentClassName,
                    )}
                >
                    {children}
                </div>
            </main>
            <GlobalSetting />
        </Layout>
    );
};

export default UserLayout;
